import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5f0e23ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5f0e23ca&prod&lang=scss&scoped=true"
import style1 from "@/styles/pc.css?vue&type=style&index=1&id=5f0e23ca&prod&scoped=true&lang=css&external"
import style2 from "./index.vue?vue&type=style&index=2&id=5f0e23ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e23ca",
  null
  
)

export default component.exports